import { Client } from '@/core/entity';
import { IClientGateway, ClientInput, PresenterFunc, UpdaterFunc } from '@/core/interface';

export class UpdateClient {
  constructor(
    private readonly clientGateway: IClientGateway,
  ) { }

  public async execute(
    id: string,
    input: ClientInput,
    presenter: PresenterFunc<Client | null>,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {
      const { cse, ...args } = input;
      const result = await this.clientGateway.updateClient(id, args, undefined, updater);

      await this.clientGateway.assignCse(result.id, cse!);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}
